import ApiConfig from '../config/api'
import BaseAction from './action.abstract'

export default class AccountingAction extends BaseAction {
  fetchOrderList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.order_list, condition)
  }

  fetchRechargeList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.recharge_list, condition)
  }
}

export const accountingAction = new AccountingAction()
